import { defineComponent as _defineComponent } from 'vue'
import { link } from 'bits/autolinker'
import { tailwindSurfaceFontClass } from 'bits/font'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceTitleDescription',
  props: {
  fontId: {
    required: true,
    type: Number,
  },
  text: {
    required: true,
    type: String,
  },
  colorScheme: {
    type: String,
    default: 'light',
  },
},
  setup(__props) {

const props = __props



const fontClass = tailwindSurfaceFontClass(props.fontId)
const hyperlinkedText = link(props.text, { className: 'break-all' })

return { __sfc: true,props, fontClass, hyperlinkedText }
}

})